module.exports = __webpack_public_path__ + "images/d7a4310eb617af82a44d6a2b31ef2b973a13a69003e500e393bfdecfb129170e.svg";